import { render } from "./Chamados.vue?vue&type=template&id=a3b0caa8"
import script from "./Chamados.vue?vue&type=script&lang=js"
export * from "./Chamados.vue?vue&type=script&lang=js"

import "./Chamados.vue?vue&type=style&index=0&id=a3b0caa8&lang=css"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__